import React, { Fragment, useContext, useEffect } from "react";
import "./App.css";
import NavBar from "./components/NavBar";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import PolicyStore from "./context/policy/PolicyStore";
import { RiskManagementProvider } from "./context/RiskManagement/RiskManagementContext";
import { RiskAssessmentProvider } from "./context/RiskAssessment/RiskAssessmentContext";
import { CompanyProfileProvider } from "./context/CompanyProfile/CompanyProfileContext";
import { IncidentResponsePlanProvider } from "./context/IncidentResponsePlan/IncidentPlanResponceContext";
import { IncidentResponsePlaybookProvider } from "./context/IncidentResponsePlaybook/IncidentResponsePlaybookContext";
import AuthContext from "./context/auth/AuthContext";
import { useUserContext } from "./context/auth/UserContext";
import { LoginPage } from "./pages/LoginPage";
import Authentication from "./components/Authentication";
import { getUserAccess } from "./helper/helper_userAccess";
import { Box, CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

function App() {
  const authContext = useContext(AuthContext);
  const { loadUser, portalUser, isPortalAuthenticated, token } = authContext;
  const {
    setCompanyProfileList,
    companyProlifeList,
    companyProfileID,
    isAppLoading,
    setUserAccess,
    userAccess,
    userId,
    setUserId,
    setIsAccessFecthing,
    showLogoutDialog,
    setShowLogoutDialog,
    setNoRoleAssigned,
  } = useUserContext();

  const fetchUserInfo = async () => {
    try {
      if (loadUser) await loadUser();
      console.log("USER INFO LOADED", portalUser, isPortalAuthenticated);
      // setUserChecked(true);
      // setAppUser(tmpUser);
    } catch (err) {
      console.log("USER INFO NOT AVAILABLE");
      // setUserChecked(false);
    }
  };
  const fetchUserAccess = async () => {
    setIsAccessFecthing(true);
    try {
      if (portalUser?.email) {
        
        const res = await getUserAccess(portalUser.email);
        if (res?.roles?.length === 0) {
          setNoRoleAssigned(true)
        } else {
          setUserAccess(res);
          setUserId(res.userInformation.userID);
          localStorage.setItem("userAccess", JSON.stringify(res));
          setIsAccessFecthing(false);
        }
      }
    } catch (err) {
      // setUserChecked(false);
    }
  };

  useEffect(() => {
    if (!portalUser) {
      fetchUserInfo();
    }
  }, []);

  useEffect(() => {
    console.log("USER INFO LOADED#", portalUser, isPortalAuthenticated);
  }, [portalUser, isPortalAuthenticated, token]);

  useEffect(() => {
    if (portalUser) {
      const retrievedUserAccess = localStorage.getItem("userAccess");
      const storedAccess = retrievedUserAccess
        ? JSON.parse(retrievedUserAccess)
        : null;
      // Check if portalUser email matches the stored email or if storedAccess is null

      if (
        !storedAccess ||
        (portalUser?.email &&
          storedAccess.userInformation?.userEmail?.toLowerCase() !==
          portalUser.email.toLowerCase())
      ) {
        fetchUserAccess();
      }
    }
  }, [portalUser]);

  return (
    <Fragment>
      <div
        style={{
          backgroundColor: "#E4EBEF",
        }}
      >
        {isPortalAuthenticated ? (
          token ? (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <CompanyProfileProvider>
                <PolicyStore>
                  <RiskManagementProvider>
                    <RiskAssessmentProvider>
                      <IncidentResponsePlanProvider>
                        <IncidentResponsePlaybookProvider>
                          <Authentication>
                            <NavBar />
                          </Authentication>
                        </IncidentResponsePlaybookProvider>
                      </IncidentResponsePlanProvider>
                    </RiskAssessmentProvider>
                  </RiskManagementProvider>
                </PolicyStore>
              </CompanyProfileProvider>
            </LocalizationProvider>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <CircularProgress />
            </Box>
          )
        ) : (
          <LoginPage />
        )}
      </div>
      {
        <Dialog open={showLogoutDialog}>
          <DialogTitle>Session Expired</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Your session has expired. Please log in again to continue.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowLogoutDialog(false)}>Ok</Button>
          </DialogActions>
        </Dialog>
      }
    </Fragment>
  );
}

export default App;
